import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { SliderStepComponent } from '../../step/slider-step/slider-step.component';
@Component({
  selector: 'app-cash-out',
  templateUrl: './cash-out.component.html',
  styleUrls: ['./cash-out.component.scss', '../../step/step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class CashOutComponent extends SliderStepComponent implements OnInit {
  public cashOutValue: number;
  public cashoutTitle: string;
  public rightLabel: string;
  public leftLabel: string;
  public Limit500k: boolean = false;
  public prevSliderValue: number;
  public disableSlider: boolean = false;

  initStep() {
    switch (this.form.value.maximumEquity)  {
      case "yes": {
        this.nextStep();
      }
      case "otherAmount": {
        this.cashoutTitle = "How much equity would you like to take out?";
        this.initializeData();
      }
      default: {
        this.checkPredefined();
      }
    }
  }

  ngOnInit() {
    this.initializeData();
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('cashOut', this.control);
    if (this.form.controls.formType.value == "heloc"){
      this.cashoutTitle = "How much equity would you like to take out?";
    } else if (this.form.controls.type.value == "personalloan") {
      this.cashoutTitle = this.form.controls.formType.value == "debtsettlement" || this.form.controls.formType.value == "debtrelief" ? "How much debt do you have?" : "How much would you like to borrow?";
    } else {
      this.cashoutTitle = "Would you like to borrow additional cash?";
    }
  }

  slide(e) {
    this.sliderValue = e.target.value;
    this.sliderDisplay = this.sliderLabels[e.target.value];
    this.cashOutValue = this.sliderValues[this.sliderValue];

    // add commas to numeric inputs
    this.enterStringFieldValue = this.sliderValues[this.sliderValue].toLocaleString();
  }

  initializeData () {
    if (this.form.controls.type.value == 'personalloan') {
      if (this.form.controls.formType.value == "debtsettlement" || this.form.controls.formType.value == "debtrelief") {
        this.leftLabel = '$20k';
        this.rightLabel = '$100k';
        this.sliderValues = [
          20000, 22500, 27500, 32500, 37500, 42500, 47500, 52500, 57500,
          62500, 67500, 72500, 77500, 82500, 87500, 92500, 97500, 100000
        ];

        this.sliderLabels = [
          'Less Than $20,000', '$20,001 - $25,000', '$25,001 - $30,000', '$30,001 - $35,000',
          '$35,001 - $40,000', '$40,001 - $45,000', '$45,001 - $50,000', '$50,001 - $55,000',
          '$55,001 - $60,000','$60,001 - $65,000', '$65,001 - $70,000', '$70,001 - $75,000',
          '$75,001 - $80,000', '$80,001 - $85,000', '$85,001 - $90,000', '$90,001 - $95,000',
          '$95,001 - $100,000', '$100,000'
        ];

        this.sliderValue = 1;
        this.sliderDisplay = this.sliderLabels[this.sliderValue];
      } else {
        this.leftLabel = '$5k';
        this.rightLabel = '$100k';
        this.sliderValues = [
          5000, 12500, 17500, 22500, 27500, 32500, 37500, 42500, 47500,
          52500, 57500, 62500, 67500, 72500, 77500, 82500, 87500, 92500,
          97500, 100000
        ];

        this.sliderLabels = [
          'Less Than $10,000', '$10,001 - $15,000', '$15,001 - $20,000', '$20,001 - $25,000', '$25,001 - $30,000',
          '$30,001 - $35,000', '$35,001 - $40,000', '$40,001 - $45,000', '$45,001 - $50,000', '$50,001 - $55,000',
          '$55,001 - $60,000','$60,001 - $65,000', '$65,001 - $70,000', '$70,001 - $75,000', '$75,001 - $80,000',
          '$80,001 - $85,000', '$85,001 - $90,000', '$90,001 - $95,000', '$95,001 - $100,000', '$100,000'
        ];

        this.sliderValue = 1;
        this.sliderDisplay = this.sliderLabels[this.sliderValue];
      }
    } else {

      this.leftLabel = '$0';
      this.rightLabel = '$500k';
      this.sliderValues = [
        0, 2500, 7500, 12500, 17500, 22500, 27500, 32500, 37500, 42500, 47500, 55000, 65000, 75000, 85000, 95000, 102500, 107500, 112500, 117500,
        122500, 127500, 132500, 137500, 142500, 147500, 152500, 157500, 162500, 167500, 172500, 177500, 182500, 187500, 192500, 197500, 205000,
        215000, 225000, 235000, 245000, 255000, 265000, 275000, 285000, 295000, 305000, 315000, 325000, 335000, 345000, 355000, 365000, 375000,
        385000, 395000, 410000, 430000, 450000, 470000, 490000, 500001
      ];

      this.sliderLabels = [
        '$0', 'Under $5,000', '$5,001 - $10,000', '$10,001 - $15,000', '$15,001 - $20,000', '$20,001 - $25,000', '$25,001 - $30,000', '$30,001 - $35,000',
        '$35,001 - $40,000', '$40,001 - $45,000', '$45,001 - $50,000', '$50,001 - $60,000', '$60,001 - $70,000', '$70,001 - $80,000', '$80,001 - $90,000',
        '$90,001 - $100,000', '$100,001 - $105,000', '$105,001 - $110,000', '$110,001 - $115,000', '$115,001 - $120,000', '$120,001 - $125,000',
        '$125,001 - $130,000', '$130,001 - $135,000', '$135,001 - $140,000', '$140,001 - $145,000', '$145,001 - $150,000', '$150,001 - $155,000',
        '$155,001 - $160,000', '$160,001 - $165,000', '$165,001 - $170,000', '$170,001 - $175,000', '$175,001 - $180,000', '$180,001 - $185,000',
        '$185,001 - $190,000', '$190,001 - $195,000', '$195,001 - $200,000', '$200,001 - $210,000', '$210,001 - $220,000', '$220,001 - $230,000',
        '$230,001 - $240,000', '$240,001 - $250,000', '$250,001 - $260,000', '$260,001 - $270,000', '$270,001 - $280,000', '$280,001 - $290,000',
        '$290,001 - $300,000', '$300,001 - $310,000', '$310,001 - $320,000', '$320,001 - $330,000', '$330,001 - $340,000', '$340,001 - $350,000',
        '$350,001 - $360,000', '$360,001 - $370,000', '$370,001 - $380,000', '$380,001 - $390,000', '$390,001 - $400,000', '$400,001 - $420,000',
        '$420,001 - $440,000', '$440,001 - $460,000', '$460,001 - $480,000', '$480,001 - $500,000', 'Over $500,000'
      ];

      if (this.form.controls.formType.value == 'heloc' || this.form.controls.type.value == 'refinance') {
        this.sliderValue = 11;
      } else {
        this.sliderValue = 0;
      }
      this.sliderDisplay = this.sliderLabels[this.sliderValue];
    }



    //   Data for a potential 1m check
    //   this.sliderValues = [
    //     0, 2500, 7500, 12500, 17500, 22500, 27500, 32500, 37500, 42500, 47500, 55000, 65000, 75000, 85000, 95000, 102500, 107500, 112500, 117500,
    //     122500, 127500, 132500, 137500, 142500, 147500, 152500, 157500, 162500, 167500, 172500, 177500, 182500, 187500, 192500, 197500, 205000,
    //     215000, 225000, 235000, 245000, 255000, 265000, 275000, 285000, 295000, 305000, 315000, 325000, 335000, 345000, 355000, 365000, 375000,
    //     385000, 395000, 410000, 430000, 450000, 470000, 490000, 510000, 530000, 550000, 570000, 590000, 610000, 630000, 650000, 670000, 690000,
    //     710000, 730000, 750000, 770000, 790000, 810000, 830000, 850000, 870000, 890000, 910000, 930000, 950000, 970000, 990000, 1000001
    //   ];
    //   this.sliderLabels = [
    //     '$0','Under $5,000','$5,001 - $10,000','$10,001 - $15,000','$15,001 - $20,000','$20,001 - $25,000','$25,001 - $30,000', '$30,001 - $35,000',
    //     '$35,001 - $40,000','$40,001 - $45,000','$45,001 - $50,000','$50,001 - $60,000','$60,001 - $70,000','$70,001 - $80,000', '$80,001 - $90,000',
    //     '$90,001 - $100,000', '$100,001 - $105,000', '$105,001 - $110,000', '$110,001 - $115,000', '$115,001 - $120,000', '$120,001 - $125,000',
    //     '$125,001 - $130,000', '$130,001 - $135,000', '$135,001 - $140,000', '$140,001 - $145,000', '$145,001 - $150,000', '$150,001 - $155,000',
    //     '$155,001 - $160,000', '$160,001 - $165,000', '$165,001 - $170,000', '$170,001 - $175,000', '$175,001 - $180,000', '$180,001 - $185,000',
    //     '$185,001 - $190,000', '$190,001 - $195,000', '$195,001 - $200,000', '$200,001 - $210,000', '$210,001 - $220,000', '$220,001 - $230,000',
    //     '$230,001 - $240,000', '$240,001 - $250,000', '$250,001 - $260,000', '$260,001 - $270,000', '$270,001 - $280,000', '$280,001 - $290,000',
    //     '$290,001 - $300,000', '$300,001 - $310,000', '$310,001 - $320,000', '$320,001 - $330,000', '$330,001 - $340,000', '$340,001 - $350,000',
    //     '$350,001 - $360,000', '$360,001 - $370,000', '$370,001 - $380,000', '$380,001 - $390,000', '$390,001 - $400,000', '$400,001 - $420,000',
    //     '$420,001 - $440,000', '$440,001 - $460,000', '$460,001 - $480,000', '$480,001 - $500,000', '$500,001 - $520,000', '$520,001 - $540,000',
    //     '$540,001 - $560,000', '$560,001 - $580,000', '$580,001 - $600,000', '$600,001 - $620,000', '$620,001 - $640,000', '$640,001 - $660,000',
    //     '$660,001 - $680,000', '$680,001 - $700,000', '$700,001 - $720,000', '$720,001 - $740,000', '$740,001 - $760,000', '$760,001 - $780,000',
    //     '$780,001 - $800,000', '$800,001 - $820,000', '$820,001 - $840,000', '$840,001 - $860,000', '$860,001 - $880,000', '$880,001 - $900,000',
    //     '$900,001 - $920,000', '$920,001 - $940,000', '$940,001 - $960,000', '$960,001 - $980,000', '$980,001 - $1,000,000', 'Over $1,000,000'
    //   ];
  }

  checkPredefined() {
    if (this.form.controls.preCashOut.value > 0) {
      this.cashOutValue = this.form.controls.preCashOut.value;
      this.form.controls.cashOut.setValue(this.cashOutValue);
      this.nextStep();
      return true;
    }

    return false;
  }

  setSlide(e) {
    let value = isNaN(e) ? parseFloat(e.target.value.replace(/,/g, '')) : e;
    value = isNaN(value) ? 0 : value;
    for(var i = 0; i < this.sliderValues.length; i++) {
      if (value <= 50000) {
        var diff = 2500;
      } else {
        var diff = 5000;
      }
      if ((this.sliderValues[i] - diff) < value && (this.sliderValues[i + 1] == undefined || (this.sliderValues[i + 1] - diff) >= value)) {
        this.sliderValue = i;
        break;
      }
    }

    //add commas to numeric inputs
    this.enterStringFieldValue = value.toLocaleString();

    this.cashOutValue = value;
    this.sliderDisplay = this.sliderLabels[this.sliderValue];
  }

  setMaxEquity () {
    // Sets maximum equity value
    this.form.controls.maximumEquity.setValue(this.form.controls.maximumEquity.value === "yes" ? "no" : "yes");

    if (this.form.controls.maximumEquity.value === "yes") {
      this.prevSliderValue = this.sliderValue; // Saves most recent given slider value
      this.cashOutValue = null; // Nulls out cashout value field
    } else {
      this.sliderValue = this.prevSliderValue; // Sets slider to most recent value slider was adjusted to
      this.cashOutValue = this.sliderValues[this.sliderValue]; // Sets cashout/equity val
    }
    this.sliderDisplay = this.form.controls.maximumEquity.value === "yes" ? 'Maximum Equity' : this.sliderLabels[this.sliderValue];
    this.enterStringFieldValue = this.form.controls.maximumEquity.value === "yes" ? '' : this.sliderValues[this.sliderValue].toLocaleString();

    let value = parseFloat(this.enterStringFieldValue.replace(/,/g, ''));
    value = isNaN(value) ? 0 : value;
    this.cashOutValue = this.form.controls.maximumEquity.value === "yes" ? null : value;
  }

  countVisitorAction() {
    this.form.controls.cashOutAction.setValue('1');
  }
}
